/**
 * Ordre de saisie d'une liste, celui que montre la maquette V288.
 *
 * <p>Le serveur renvoie certaines collections triées par nom (stock,
 * employés) ou de la plus récente à la plus ancienne (commandes, bons de
 * livraison). L'écran les présente dans l'ordre où elles ont été créées :
 * l'identifiant numérique croissant. Une ligne encore provisoire (identifiant
 * non numérique, pas encore synchronisée) vient en dernier, dans l'ordre
 * reçu.
 *
 * @template T
 * @param {T[]} liste éléments portant un {@code id}
 * @returns {T[]} une copie triée, la liste reçue restant intacte
 */
export function ordreDeSaisie(liste) {
  const num = (x) =>
    typeof x?.id === 'number' ? x.id : /^\d+$/.test(String(x?.id)) ? +x.id : null;
  return (liste || [])
    .map((x, i) => ({ x, i, n: num(x) }))
    .sort((a, b) => {
      if (a.n != null && b.n != null) return a.n - b.n;
      if (a.n != null) return -1;
      if (b.n != null) return 1;
      return a.i - b.i;
    })
    .map((e) => e.x);
}
